"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WindowScroller = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ScrollManager = require("./ScrollManager");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ManagedWindowScroller extends _react.default.Component {
  componentDidMount() {
    const manager = this.props.manager;

    if (manager) {
      manager._restoreInitial();
    } else {
      console.warn('WindowScroller only works when nested within a ScrollManager'); // eslint-disable-line no-console
    }
  }

  componentDidUpdate() {
    const manager = this.props.manager;

    if (manager) {
      manager._restoreWindow();
    }
  }

  render() {
    return this.props.children;
  }

}

ManagedWindowScroller.propTypes = {
  manager: _propTypes.default.instanceOf(_ScrollManager.ScrollManager).isRequired,
  children: _propTypes.default.node
};
const WindowScroller = (0, _ScrollManager.withManager)(ManagedWindowScroller);
exports.WindowScroller = WindowScroller;